import request from '@/utils/request'


// 查询公司专区列表
export function listCompany(query) {
  return request({
    url: '/company/company/list',
    method: 'get',
    params: query
  })
}

// 查询公司专区分页
export function pageCompany(query) {
  return request({
    url: '/company/company/page',
    method: 'get',
    params: query
  })
}

// 查询公司专区详细
export function getCompany(data) {
  return request({
    url: '/company/company/detail',
    method: 'get',
    params: data
  })
}

// 新增公司专区
export function addCompany(data) {
  return request({
    url: '/company/company/add',
    method: 'post',
    data: data
  })
}

// 修改公司专区
export function updateCompany(data) {
  return request({
    url: '/company/company/edit',
    method: 'post',
    data: data
  })
}

// 删除公司专区
export function delCompany(data) {
  return request({
    url: '/company/company/delete',
    method: 'post',
    data: data
  })
}
